import { GlobalState } from "little-state-machine";

export const updateSitesFiltered = (state: GlobalState, sitesFiltered: string[]) => ({
  ...state,
  sitesFiltered
});
